import React from "react"

interface DragIconProps {
    width?: number
    height?: number
    color?: string
    className?: string
}

export const DragIcon = ({ width = 32, height = 32, color = "#8B8B8B", className }: DragIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`"0 0 ${width} ${height}"`} fill="none" className={className}>
        <path d="M2 5H13" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 8H13" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 11H13" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
